var render, staticRenderFns
import script from "./AxInputGroup.vue?vue&type=script&lang=ts&"
export * from "./AxInputGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AxInputGroup.vue?vue&type=style&index=0&id=7e623b74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports